import { compose, applyMiddleware, createStore } from "redux";
import { persistStore } from "redux-persist";
import thunk from "redux-thunk";
import reducer from "../redux";
import { routerMiddleware } from "react-router-redux";
import { dropStaleActionSyncKey } from "./dropStaleActionSyncKey";

export default function configureStore(history) {
	const store = createStore(
		reducer,
		compose(applyMiddleware(thunk, routerMiddleware(history)))
	);

	const persistor = persistStore(store);

	// redux-persist batches writes on a timer (see `throttle` in ../redux).
	// Several flows dispatch a state change and then reload the page a few
	// hundred ms later -- notably "New" -> "No, Don't Save and Continue", which
	// calls purgeCanvas() and then window.location.reload() after 500ms. If the
	// throttle window is longer than that delay, the cleared canvas never
	// reaches localStorage and the old drawings rehydrate after the reload.
	// Flushing on unload drains any pending write synchronously, which covers
	// all ~13 reload sites across the three editors at once rather than needing
	// a flush threaded through each of them.
	window.addEventListener("beforeunload", () => {
		persistor.flush();
	});

	dropStaleActionSyncKey();

	return { persistor, store };
}
